<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';

	//Stores
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	//Helpers
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';

	//Types
	import type { Device } from '../../../../../types/Device';
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	import type { InputClickEvent } from '../../../../../types/InputClickEvent';

	//Design system components
	import { Button, Toggle, Alert } from '@Shelly/shelly-design-system';
	export let device: Device;

	const settings = readDeviceSettings(device.id);
	let correctionEnabled = settings[device.category + 's'][0].calibration_correction;
	let loading = false;

	const calibrate = async (): Promise<void> => {
		let res: SettingRequest = await postReq(
			`/device/generic_command`,
			{
				id: device.id,
				command: `calibrate`,
				payload: JSON.stringify({}),
			},
			40000,
		);

		onSettingsResponse(res, device, {
			success: $format('calibration_started_scc_toast'),
		});
	};

	const saveToggle = async (e: InputClickEvent): Promise<void> => {
		loading = true;
		correctionEnabled = e.target.checked;
		const res: SettingRequest = await postReq(
			`/device/generic_command`,
			{
				id: device.id,
				command: 'calibration_correction',
				payload: JSON.stringify({
					enabled: correctionEnabled,
				}),
			},
			40000,
		);

		if (!res?.isok) {
			correctionEnabled = !correctionEnabled;
		}

		onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Toggle
	size="m"
	class="mb-s"
	disabled={loading}
	checked={correctionEnabled}
	on:click={saveToggle}
	id="toggle-2ydajat"
>
	{$format('label_enable_auto_correction', {
		default: 'Enable automatic correction.',
	})}
</Toggle>

<Alert
	class="mb-s"
	heading={$format('alert_auto_correction', {
		default: 'If enabled, device will automatically correct calibration if needed.',
	})}
/>
{#if !$showNewLayout}
	<Button size="m" width="full" on:click={calibrate}>
		{$format('button_start_calibration')}
	</Button>
{/if}
